import type { ImageProps } from '@archipro-design/aria';
import { Image } from '@archipro-design/aria';
import React, { useRef, useState } from 'react';
import PaintPickerShellV2 from '~/modules/paint-picker-new/component/paint-picker-shell/PaintPickerShell';
import PaintPickerMobileShellV2 from '~/modules/paint-picker-new/component/paint-picker-shell/PaintPickerMobileShell';
import { useFeatureFlaggedPaintPickerContext } from '@modules/paint-picker-new/hooks/useFeatureFlaggedPaintPickerContext';

type ImageWithPaintPickerArticleProps = ImageProps;

const ImageWithPaintPickerArticle = (
    props: ImageWithPaintPickerArticleProps,
) => {
    const {
        pickerContext: {
            state: {
                paintPickerActive,
                isEnabled,
                isPicking,
                activeImageSrc,
                touchEnabled,
            },
            paintSelection,
            availablePaints,
        },
    } = useFeatureFlaggedPaintPickerContext();

    const [imageLoaded, setImageLoaded] = useState(false);
    const imageRef = useRef<HTMLImageElement | null>(null);
    const showDesktopShell =
        !touchEnabled &&
        isEnabled &&
        availablePaints.length > 0 &&
        (isPicking || paintSelection.length < 1);
    const showMobileShell =
        touchEnabled && paintPickerActive && activeImageSrc === props.src;

    const PaintPickerShell = PaintPickerShellV2;
    const PaintPickerMobileShell = PaintPickerMobileShellV2;

    return (
        <>
            <Image
                {...props}
                onLoadingComplete={(result) => {
                    imageRef.current = result;
                    setImageLoaded(true);
                }}
            />
            {imageLoaded && showDesktopShell && (
                <PaintPickerShell
                    imageRef={imageRef.current}
                    imageSrc={props.src}
                />
            )}
            {showMobileShell && (
                <PaintPickerMobileShell imageRef={imageRef.current} />
            )}
        </>
    );
};

export default ImageWithPaintPickerArticle;
